import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import * as css from './ScrollHint.scss';

class ScrollHint extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    scrollToPosition: PropTypes.number,
    hideOnScroll: PropTypes.bool,
  };

  static defaultProps = {
    hideOnScroll: true,
  };

  state = {
    hidden: false,
  };

  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this._handleScroll);
      if (window.pageYOffset > 0) {
        this._handleScroll();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleScroll);
  }

  _handleScroll = () => {
    window.removeEventListener('scroll', this._handleScroll);
    if (this.props.hideOnScroll) {
      this.setState({ hidden: true });
    }
  };

  _handleClick = e => {
    e.preventDefault();
    const { scrollToPosition } = this.props;

    const targetPosition = scrollToPosition ?? window.innerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth',
    });
  };

  render() {
    const { label, className } = this.props;
    const { hidden } = this.state;

    return (
      <button
        className={cn(css.hint, { [css.hidden]: hidden }, className)}
        onClick={this._handleClick}
        ref={node => (this.hint = node)}
        title={label}
      >
        <svg focusable="false">
          <use xlinkHref="#icon-arrow-up"></use>
        </svg>
      </button>
    );
  }
}

export default ScrollHint;
